import { Absence } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { ABSENCES_PAST_QUERY_KEY, ABSENCES_URL, ABSENCES_QUERY_KEY } from './queryConstants'
import dayjs from 'dayjs'
import { getQueryParams } from 'utils/getQueryParams'

type UseAbsencesPastListProps = {
  users?: [string | undefined]
  absenceType?: string
}

type UseAbsencesPastListReturn = {
  pastAbsences: Absence[]
  isPastAbsencesLoading: boolean
}

export const useAbsencesPastList = ({
  users,
  absenceType,
}: UseAbsencesPastListProps): UseAbsencesPastListReturn => {
  const pastAbsencesQueryParams = getQueryParams({
    endDate: dayjs().subtract(1, 'day').endOf('day').toISOString(),
    users,
    absenceType,
  })

  const { data: pastAbsencesData, isLoading: isPastAbsencesLoading } = useQuery(
    [ABSENCES_QUERY_KEY, ABSENCES_PAST_QUERY_KEY, users?.join('-'), absenceType],
    () =>
      getJSON({
        url: `${ABSENCES_URL}?${pastAbsencesQueryParams}`,
        isRota: true,
      }),
    { enabled: true }
  )

  return {
    pastAbsences: pastAbsencesData?.data || [],
    isPastAbsencesLoading,
  }
}
